module.exports = __webpack_public_path__ + "img/医药.875e617d.png";